import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/tabs.module.scss';

import type { ITabsProps } from '../../types';

export const Tabs = ({
  tabs,
  activeCard,
  tabButtonRefs,
  tabsContainerRef,
  onTabClick
}: ITabsProps) => {
  return (
    <div className={styles.tabsWrapper}>
      <div 
        ref={tabsContainerRef}
        className={generateClassName([styles.tabs,'contained', 'inlinePadding'])}
      >
        {tabs.map((tab, index) => (
          <button 
            key={index}
            ref={(node) => tabButtonRefs.current[index] = node}
            onClick={(e) => onTabClick(e, index)} 
            type="button" 
            className={generateClassName([styles.tab, activeCard === index ? styles.active : ''])}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};
